import { CheckCircle, MinusCircle, XmarkCircle } from 'iconoir-react'

type SmsConsentCellProps = {
  value: boolean | null | undefined
}

export function SmsConsentCell({ value }: SmsConsentCellProps) {
  const Icon = value ? CheckCircle : value === false ? XmarkCircle : MinusCircle
  const tone = value ? `text-success-default` : value === false ? `text-danger-default` : `text-minimal`
  const label = value ? `Opted in` : value === false ? `Opted out` : `Empty`
  return (
    <span className="inline-flex items-center gap-1.5">
      <Icon className={`h-4 w-4 shrink-0 ${tone}`} strokeWidth={2} aria-hidden />
      <span>{label}</span>
    </span>
  )
}
